import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Modal from 'react-modal';
import './modal.css';

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_LAZ || '',
  auth: { username: 'Portal', password: 'Portal1163' },
});

export function stripHtml(html) {
  return (html || '').replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();
}

const AbrirChamadoModal = ({ data, onClose }) => {
  const [descricao, setDescricao] = useState('');
  const [loading, setLoading] = useState(false);
  const [erro, setErro] = useState(null);
  const [sucesso, setSucesso] = useState(null);
  const [tecnicos, setTecnicos] = useState([]);
  const [tecnicoId, setTecnicoId] = useState('');
  const [carregandoTecnicos, setCarregandoTecnicos] = useState(false);

  useEffect(() => {
    if (data) {
      setDescricao(data.descricao || '');
      setErro(null);
      setSucesso(null);
      setLoading(false);
      setTecnicoId('');
      setCarregandoTecnicos(true);
      axiosInstance.get('/tecnicos')
        .then((response) => setTecnicos(response.data || []))
        .catch(() => setErro('Não foi possível carregar a lista de usuários do laz_gerencia.'))
        .finally(() => setCarregandoTecnicos(false));
    }
  }, [data]);

  const confirmar = async () => {
    setLoading(true);
    setErro(null);
    try {
      const response = await axiosInstance.post('/chamado', {
        cnpj: data.cnpj,
        nome: data.nome,
        descricao,
        tecnicoId,
      });
      setSucesso(response.data?.controle ?? true);
    } catch (error) {
      setErro(error.response?.data?.error || 'Erro ao abrir chamado no laz_gerencia.');
    } finally {
      setLoading(false);
    }
  };

  const fechar = () => {
    onClose();
  };

  return (
    <Modal
      isOpen={!!data}
      onRequestClose={fechar}
      contentLabel='Abrir chamado'
      className='react-modal-content'
      overlayClassName='react-modal-overlay'
    >
      <div className='modal-header modal-header-wrapper'>
        <h5 className="modal-title">Abrir chamado no laz_gerencia</h5>
        <button type="button" className="btn-close" aria-label="Fechar" onClick={fechar}></button>
      </div>

      {data && (
        <div>
          {sucesso ? (
            <div className="alert alert-success" role="alert">
              Chamado {typeof sucesso === 'number' ? `#${sucesso} ` : ''}aberto com sucesso.
            </div>
          ) : (
            <>
              <p className="mb-1"><strong>Cliente:</strong> {data.nome}</p>
              <p className="mb-3"><strong>CNPJ:</strong> {data.cnpj}</p>
              <div className="mb-3">
                <label className="form-label"><strong>Para qual usuário vai o chamado?</strong></label>
                <select
                  className="form-select"
                  value={tecnicoId}
                  onChange={(e) => setTecnicoId(e.target.value)}
                  disabled={loading || carregandoTecnicos}
                >
                  <option value="">{carregandoTecnicos ? 'Carregando...' : 'Selecione um usuário'}</option>
                  {tecnicos.map((t) => (
                    <option key={t.controle} value={t.controle}>{t.nome}</option>
                  ))}
                </select>
              </div>
              <div className="mb-3">
                <label className="form-label"><strong>Descrição</strong></label>
                <textarea
                  className="form-control"
                  rows={6}
                  value={descricao}
                  onChange={(e) => setDescricao(e.target.value)}
                  disabled={loading}
                />
              </div>
              {erro && <div className="alert alert-danger" role="alert">{erro}</div>}
            </>
          )}
        </div>
      )}

      <div className="modal-footer justify-content-end">
        {sucesso ? (
          <button className='btn btn-primary' onClick={fechar}>Fechar</button>
        ) : (
          <>
            <button className='btn btn-outline-secondary' onClick={fechar} disabled={loading}>Cancelar</button>
            <button className='btn btn-primary' onClick={confirmar} disabled={loading || !tecnicoId}>
              {loading ? 'Abrindo...' : 'Confirmar abertura'}
            </button>
          </>
        )}
      </div>
    </Modal>
  );
};

export default AbrirChamadoModal;
